export const isValidHour = (hour: string): boolean => {
  const regexToVerifyValidHour = /^([0-1][0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

  return regexToVerifyValidHour.test(hour);
};
